import ShipperOrderTableGroup from './ShipperOrderTableGroup';

export default ShipperOrderTableGroup;
